export default __webpack_public_path__ + "static/3-install-netlify-01298a392d59988bff8a0f341a0f8df9.png";